import { mapState, mapGetters, mapActions } from 'vuex'

export const appAuthComputed = {
  ...mapState('appAuth', {
    appSession: (state) => state.appSession,
  }),
  ...mapGetters('appAuth', ['appLoggedIn','updateCompanyInfo']),
}

export const appAuthMethods = mapActions(
  'appAuth', ['appLogIn', 'companyInfoExists'])


export const authComputed = {
  ...mapState('auth', {
    currentSession: (state) => state.currentSession,
  }),
  ...mapGetters('auth', ['loggedIn']),
}

export const authMethods = mapActions(
  'auth', ['logIn', 'logOut', 'register',
  'resetPassword', 'setUserActiveSection'])



export const usersMethods = mapActions(
  'users', [
    'fetchUsers', 'createUpdateUsers',
    'deleteUsers', 'changePassword',
    'updatePhotos', 'fetchUsersDetail',
  'fetchUsersForOptions']
)

export const permsComputed = {
  ...mapState('perms', {
    cached: (state) => state.cached,
  }),
}

export const permsMethods = mapActions(
  'perms', ['fetchPerms', 'createUpdatePerms',
  'deletePerms', 'fetchPermsDetail'])


export const groupsComputed = {
  ...mapState('groups', {
    cached: (state) => state.cached,
  }),
}

export const groupsMethods = mapActions(
  'groups', ['fetchGroups', 'createUpdateGroups',
  'deleteGroups', 'fetchGroupsDetail'])

export const appSectionsComputed = {
  ...mapState('appSections', {
    cached: (state) => state.cached,
  }),
}

export const appSectionsMethods = mapActions(
  'appSections', ['fetchAppSections', 'createUpdateAppSections',
  'deleteAppSections', 'fetchAppSectionsDetail'])



export const companyInfoComputed = {
  ...mapState('companyInfo', {
    cached: (state) => state.cached,
  }),
}

export const companyInfoMethods = mapActions(
  'companyInfo', ['fetchCompanyInfo', 'createUpdateCompanyInfo', 'setFileCompanyInfo'])



export const projectsMethods = mapActions(
  'project', [
    'methodologistProject', 'createProfileProject', 'masterCreateUpdate',
    'masterDelete','findPublicProject','findExpertPerProject'
  ])

export const methodologistMethods = mapActions(
  'methodologist', [
    'createExpert','updateExpert','createPublicExpert'
  ]
)

export const pronosticsMethods = mapActions(
  'pronostics', [
    'fetchPronostics', 'createUpdatePronostic', 'deletePronostic',
    'fetchForecasters', 'fetchProjects'
  ]
)

export const expertMethods = mapActions(
  'expert', [
    'setLoading', 'rateScene', 'updateRateScene', 'fetchSceneriesRated',
    'saveScene'
  ]
)